module.exports = __webpack_public_path__ + "assets/img/videocam.64d8d081.svg";